// extracted by mini-css-extract-plugin
export default {"container":"bread_crumbs_container__DW0tT","crumbsLink":"bread_crumbs_crumbsLink__n5NGS","crumbsLinkActive":"bread_crumbs_crumbsLinkActive__AQWz4"};